<template>
  <div class="tableStyle">
    <div class="tableBox">
      <div id="leftBox" class="organizaLeft" style="width: 800px">
        <vue-draggable-resizable
          style="height: 100%"
          :min-width="600"
          @resizing="onResize"
          :max-width="1000"
          :draggable="false"
          :handles="['mr']"
          :w="800"
          :parent="false"
        >
          <el-scrollbar>
            <tree :isSearch="isSearch" @initFun="initQuery" @nodeClick="nodeClick"></tree>
          </el-scrollbar>
        </vue-draggable-resizable>
      </div>
      <div class="carDisRight" style="padding-left: 16px;">
        <div class="carInsTitle">
          <el-scrollbar>
            <div class="carInsTitleTop">
              <div class="carInsTopBox" style="border:none;">
                <div class="carInsTopLeft">{{$t('PlatformSettings.orgDetail')}}</div>
              </div>
              <div class="carDisNewsBox">
                <el-row :gutter="20">
                  <el-col :span="10">
                    <div class="carInsNews">
                      <p>{{$t('PlatformSettings.superId')}}</p>
                      <el-input
                        v-model="Details.upid"
                        readonly
                        autocomplete="off"
                      ></el-input>
                    </div>
                    <div class="carInsNews">
                      <p>{{$t('PlatformSettings.level')}}</p>
                      <el-input
                        v-model="Details.level"
                        readonly
                        autocomplete="off"
                      ></el-input>
                    </div>
                    <div class="carInsNews">
                      <p>{{$t('common.updateTime')}}</p>
                      <el-input
                        v-model="Details.updateTime"
                        readonly
                        autocomplete="off"
                      ></el-input>
                    </div>
                  </el-col>
                  <el-col :span="10" :offset="4">
                    <div class="carInsNews">
                      <p>{{$t('PlatformSettings.lowerNum')}}</p>
                      <el-input
                        v-model="Details.childrenNum"
                        readonly
                        autocomplete="off"
                      ></el-input>
                    </div>
                    <div class="carInsNews">
                      <p>{{$t('common.setUpTime')}}</p>
                      <el-input
                        v-model="Details.createTime"
                        readonly
                        autocomplete="off"
                      ></el-input>
                    </div>
                    <div class="carInsNews">
                      <p>{{$t('common.lastUser')}}</p>
                      <el-input
                        v-model="Details.lastUser"
                        readonly
                        autocomplete="off"
                      ></el-input>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-scrollbar>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import organizaManagement from "./organizaManagement.js";
export default organizaManagement;
</script>

<style lang="less" scoped>
@import "../../../assets/styles/Style.less";
</style>
